import { forwardRef } from 'react';
import classNames from 'classnames/bind';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';

import withComponentName from '../../../../decorators/withComponentName';

import loadable from '../../../../utils/loadable';

import Styles from '../../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const InputMask = loadable(() => import('react-input-mask'));

const RenderCustomHeader = (props) => {
  const {
    date, increaseMonth, decreaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled,
  } = props;
  return (
    <div className={Styles.datepicker_month_header}>
      <div className={cx('datepicker_month_left', { disable: prevMonthButtonDisabled })}>
        <FontAwesomeIcon icon={faChevronLeft} onClick={decreaseMonth} />
      </div>
      <div className={cx('datepicker_month_right', { disable: nextMonthButtonDisabled })}>
        <FontAwesomeIcon icon={faChevronRight} onClick={increaseMonth} />
      </div>
      <div className={Styles.datepicker_month_header_text}>
        {moment(date).format('MMM YYYY')}
      </div>
    </div>
  );
};

const CalendarItem = forwardRef((
  {
    dateType,
    startDate,
    endDate,
    visibleInputItem,
    inputDateValue,
    typeDate,
    inputDatePeriod,
    showInput,
    visibleInput,
    typeTime,
    timePeriodValue,
    timePeriodItem,
    onDatesChange,
    minDate,
    selectedDate,
    maxDate,
    selectsEnd,
    selectsStart,
    title,
    width,
    errorMargin,
    earliestSearchDate,
    earliestDateErr,
    timeInputWrapperClass,
    isInputDisabled,
  },
  ref,
) => {
  const getSelectedPeriodStyle = (date) => {
    if (moment(startDate).isBefore(moment(date)) && moment(moment(endDate).subtract(1, 'days')).isAfter(moment(date))) {
      return `${cx('selected_period_days')}`;
    }
  };
  return (
    <div className={cx('calendar-wrapper', { disabled: !startDate }, { 'error-display': errorMargin })}>
      <div className={cx('time-input-wrapper', timeInputWrapperClass, { 'input-to': title === 'To' })}>
        <div className={Styles['time-value']}>
          <p>{title}</p>
        </div>
        <div className={cx('date', { 'visible-input': visibleInputItem, 'earliest-error': earliestDateErr && selectsStart })}>
          <InputMask
            name={dateType}
            className={Styles['date-input']}
            onChange={(e) => typeDate(e, dateType, inputDatePeriod, timePeriodItem)}
            mask="99-99-9999"
            autoFocus
            disabled={isInputDisabled}
            ref={ref}
            value={inputDateValue}
          />
          <div
            onClick={() => showInput(visibleInput)}
            className={Styles['date-input-imitation']}
          >
            {moment(selectedDate).format('DD-MM-YYYY')}
          </div>
        </div>
        <div
          className={cx('time-input', { 'earliest-error': earliestDateErr && selectsStart })}
        >
          <InputMask
            name={dateType}
            onChange={(e) => typeTime(e, timePeriodItem, dateType)}
            mask="99:99"
            autoFocus
            disabled={isInputDisabled}
            value={timePeriodValue}
          />
        </div>
      </div>
      {width > 767 && (
      <DatePicker
        selected={selectedDate}
        onChange={(date) => onDatesChange(date, dateType, inputDatePeriod, timePeriodItem)}
        selectsEnd={selectsEnd}
        selectsStart={selectsStart}
        maxDate={maxDate}
        startDate={dateType === 'startDate' && startDate}
        endDate={dateType === 'endDate' && endDate}
        minDate={minDate}
        inline
        className={Styles['custom-datepicker']}
        dayClassName={(date) => getSelectedPeriodStyle(date)}
        dateFormat="dd/MM/yyyy"
        highlightDates={earliestDateErr ? [earliestSearchDate] : undefined}
        renderCustomHeader={RenderCustomHeader}
      />
      )}
    </div>
  );
});

export default withComponentName(CalendarItem);
